export default "__VITE_ASSET__W1oHEs5r__"